var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-loader"},[_c('img',{staticClass:"spinner-loader__image",attrs:{"src":require("@/assets/spinner-loader.gif"),"alt":_vm.$t('collections.loading__text')}}),_c('span',{staticClass:"spinner-loader__text"},[_vm._v(" "+_vm._s(_vm.$t('collections.loading__text'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }